import React, { useEffect, useState } from 'react'
import Submenu from '../../UI/menu/submenu/Submenu'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const SubmenuWarehouse = () => {

    const [list, setList] = useState([])

    useEffect(() => {
        setMenu()
    }, [])

    const setMenu = () => {
        const listTemp = []

        listTemp.push({
            url: '/warehouse/work-place',
            name: 'Робоче місце',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })
        listTemp.push({
            url: '/warehouse/packing',
            name: 'Пакування партії',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })
        listTemp.push({
            url: '/warehouse/confirm',
            name: 'Підтвердження пакування',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })

        setList(listTemp)
    }
    
  return (
    <Submenu 
        list={list}
    />
  )
}

export default SubmenuWarehouse